import React from "react";
import { motion } from "framer-motion";

const stats = [
  { value: "11+", label: "Premium Locations" },
  { value: "30+", label: "Min Avg Dwell Time" },
  { value: "UHNI", label: "Target Audience" },
  { value: "Elite", label: "Golf & Private Clubs" },
];

const ease = [0.22, 1, 0.36, 1];

const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="relative -mt-16 md:-mt-24 z-20 max-w-7xl mx-auto px-6 md:px-12"
    >
      <div className="hairline bg-ivory-soft/85 backdrop-blur-2xl shadow-luxe">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.7, ease, delay: i * 0.08 }}
              className="px-6 py-10 md:py-12 border-r border-b border-forest-800/10 last:border-r-0 md:[&:nth-child(4)]:border-r-0 [&:nth-child(2)]:border-r-0 md:[&:nth-child(2)]:border-r [&:nth-child(3)]:border-b-0 md:[&:nth-child(3)]:border-b-0 [&:nth-child(4)]:border-b-0"
              data-testid={`stat-card-${i}`}
            >
              <div className="font-serif text-5xl md:text-6xl text-brass font-light">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] md:text-xs tracking-[0.25em] uppercase text-forest-500">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
